module.exports = __webpack_public_path__ + "img/angle-4.4bc9de38.png";